import DownloadResumeButton from "./DownloadResumeButton";
import WavingHand from "./WavingHand";

const Data = () => {
  return (
    <div className="home__data">
      <h1 className="home__title gradient_text">Sa'ad</h1>
      <h3 className="home__subtitle">Web Developer | Shopify Expert</h3>
      <p className="home__description">
        Hi <WavingHand /> there! I'm Sa'ad, a passionate Web Developer
        specializing in <b className="occupassion">Shopify Theme Develoment</b>.
        Currently, I’m expanding my expertise into{" "}
        <b>Shopify App Development</b> to create more powerful e-commerce
        solutions.
      </p>
      <DownloadResumeButton />
    </div>
  );
};

export default Data;
